

































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Resource, ResourceType } from '@/store/modules/resource'
import axios from 'axios'
import { lookup } from 'mime-types'
import { saveAs } from 'file-saver'
import { EventBus } from '@/utils/event-bus'
import pdfjsLib from 'pdfjs-dist/webpack'
import 'pdfjs-dist/build/pdf.worker.entry'

@Component
export default class ResourcePreviewModal extends Vue {
  @Prop({ default: '', required: false })
  resource?: Resource;

  resourceMimeType: string = '';
  fileSrc: string = '';
  disableDownload:boolean = true;
  isHidden:boolean = true;
  canDownloadFile:boolean = true;
  resourceTypes: ResourceType[] = [];

  async mounted () {
    await this.$store.dispatch('loadResourceTypes')
    this.resourceTypes = this.$store.getters.getResourceTypes
    this.$root.$on('bv::modal::hide', (bvEvent: any, modalId: any) => {
      this.fileSrc = ''
      this.resourceMimeType = ''
    })
  }

  async loadContent () {
    EventBus.$emit('show-loader')
    this.disableDownload = true
    await axios
      .get(`resources/download/${this.resource?.key}`, {
        withCredentials: true,
        responseType: 'blob'
      })
      .then(response => {
        if (this.resource !== undefined) {
          this.$store.dispatch('addEvent', { description: 'Resource view', data: { key: this.resource.key }, title: 'Resource view', eventType: 9, userAgent: navigator.userAgent, product: null, market: { key: this.$store.getters.getSelectedMarket }, trackingKey: this.resource.trackingKey })
        }
        if (response.data === undefined) {
          this.disableDownload = true
          this.$bvModal.hide('resource-preview-modal')
        } else {
          const blob = new Blob([response.data], {
            type: lookup(this.resource?.filename as string) || undefined
          })
          const objectUrl = URL.createObjectURL(blob)
          this.resourceMimeType = lookup(this.resource?.filename as string) || ''
          this.fileSrc = objectUrl
          if (this.resourceTypes.find(r => r.key === this.resource?.resourceType?.key)?.disableDownload) {
            this.canDownloadFile = false
          }

          if (this.resourceMimeType === 'application/pdf') {
            this.renderPdf(objectUrl)
          }

          // if the resource is of type image/jpeg or image/png, we can display it directly
          if (this.resourceMimeType === 'image/jpeg' || this.resourceMimeType === 'image/png') {
            // Create an image element to display the image
            const img = document.createElement('img')
            img.src = objectUrl
            img.className = 'preview-img'
            img.onload = () => {
              // Ensure the image is loaded before displaying it
              EventBus.$emit('hide-loader')
            }
            const resourceContainer = this.$refs.resourceContainer as HTMLElement
            resourceContainer.innerHTML = '' // Clear previous content
            resourceContainer.appendChild(img)
          }
          this.isHidden = false
          this.disableDownload = false
        }
      }).catch(() => {
        this.disableDownload = true
        EventBus.$emit('hide-loader')
      }).finally(() => {
        EventBus.$emit('hide-loader')
      })
  }

  async renderPdf (url: string) {
    try {
      const loadingTask = pdfjsLib.getDocument(url)
      const pdf = await loadingTask.promise
      const container = this.$refs.resourceContainer as HTMLElement

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum)
        const viewport = page.getViewport({ scale: 1.5 })
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        if (context) {
          canvas.height = viewport.height
          canvas.width = viewport.width

          const renderContext = {
            canvasContext: context,
            viewport: viewport
          }
          await page.render(renderContext).promise
          container.appendChild(canvas)
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error rendering PDF:', error)
    }
  }

  downloadFile () {
    if (this.resource !== undefined) {
      this.$store.dispatch('addEvent', { description: 'Resource download', data: { key: this.resource.key }, title: 'Resource download', eventType: 3, userAgent: navigator.userAgent, product: null, market: { key: this.$store.getters.getSelectedMarket }, trackingKey: this.resource.trackingKey })
    }
    saveAs(this.fileSrc, this.resource?.filename)
  }

  preventContextMenu (event: MouseEvent) {
    event.preventDefault()
  }
}
